import React from 'react';
import  MyVehiclesView  from '../../Views/AfterAuth/MyVehiclesView/MyVehiclesView';

const MyVehicles = () => {
    return <MyVehiclesView />;
};

export default MyVehicles;
